var _excluded = ["imgname", "width", "height", "size"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PropTypes from 'prop-types';
import withCssProps from '../../hocs/withCssProps';
import * as Imgs from './imgs';
var imgnames = ['afip', 'lpdp', 'googlePlayArgentina', 'googlePlayArgentinaDark', 'googlePlayBrasil', 'appStoreArgentina', 'appStoreBrasil', 'appStoreOlac', 'appStoreArgentinaDark'];
var AgroImg = withCssProps(function (_ref) {
  var imgname = _ref.imgname,
    width = _ref.width,
    height = _ref.height,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var Img = Imgs["IMG".concat(imgname)];
  return Img ? /*#__PURE__*/React.createElement(Img, _extends({
    height: height || size,
    width: width || size,
    role: "img"
  }, props)) : null;
});
AgroImg.propTypes = {
  imgname: PropTypes.oneOf(imgnames).isRequired,
  width: PropTypes.string,
  height: PropTypes.string,
  size: PropTypes.string
};
AgroImg.displayName = 'AgroImg';
export { AgroImg, imgnames };